import { Button } from '@mantine/core';
import type { ManualVobFormInput } from '@unify/fhir-model/schemas';

/** DEV-only sample benefits. Does not include coverageId or serviceDate. */
export const DEV_MANUAL_VOB_POPULATE_FIELDS = {
  billingCode: 'PSY',
  inforce: true,
  inNetwork: {
    copay: 25,
    coinsurance: 20,
    deductibleTotal: 500,
    deductibleRemaining: 150,
    oopMaxTotal: 3000,
    oopMaxRemaining: 2650,
    visitLimitTotal: 30,
    visitLimitRemaining: 24,
  },
  outOfNetwork: {
    copay: 50,
    coinsurance: 40,
    deductibleTotal: 1000,
    deductibleRemaining: 800,
    oopMaxTotal: 6000,
    oopMaxRemaining: 5800,
    visitLimitTotal: 20,
    visitLimitRemaining: 18,
  },
  disposition:
    'Called payer; PSY benefits confirmed. INN: $25 copay, 20% coinsurance after deductible. OON: $50 copay, 40% coinsurance after deductible.',
} as const satisfies Omit<ManualVobFormInput, 'coverageId' | 'serviceDate'>;

export function applyDevManualVobPopulate(values: ManualVobFormInput): ManualVobFormInput {
  return {
    ...values,
    ...DEV_MANUAL_VOB_POPULATE_FIELDS,
    inNetwork: { ...DEV_MANUAL_VOB_POPULATE_FIELDS.inNetwork },
    outOfNetwork: { ...DEV_MANUAL_VOB_POPULATE_FIELDS.outOfNetwork },
  };
}

export function DevPopulateManualVobButton({
  onPopulate,
}: {
  onPopulate: () => void;
}): JSX.Element | null {
  if (!import.meta.env.DEV) return null;
  return (
    <Button type="button" variant="default" onClick={onPopulate}>
      (DEV) populate
    </Button>
  );
}
